module.exports = __webpack_public_path__ + "img/ykjgbcs.87e4018d.svg";